export enum PageViewMode {
  EDIT = "edit",
  VIEW = "view",
  CREATE = "create",
}
